import { HttpService } from '@nestjs/axios';
import { BadRequestException, Body, Controller, Get, Param, Post } from '@nestjs/common'
import { Op } from 'sequelize';
import type { WhastAppMessageMessagesTextDto } from '@decet/sistema-mensajes-shared'
import {
  CRMMessageDto,
  CRMMessageDtoAttachmentDto,
  WhastAppDto,
  WhastAppMessageContactsDto,
  WhastAppMessageMessagesDto,
} from '@decet/sistema-mensajes-shared'
import { WebhookAplicacionService } from 'apps/sistema-mensajes/server/plataforma/services/aplicacion.server.services'
import { MensajeRecibidoModel } from "../../../models/mensaje-recibido.model";
import { WebhookListenerService, WebhookMensajeDto } from '../../../services/listener.server.services'
import { WebhookTipoMensajeService } from '../../../services/tipo-mensaje.server.services'

@Controller('webhook/whatsapp/:identificador')
export class WebhookMensajeRecibidoWhatsappController {
  constructor(
    private mensajeRecibido: WebhookListenerService,
    private tipoMensaje: WebhookTipoMensajeService,
    private aplicacionService: WebhookAplicacionService,
    private httpClient: HttpService
  ) {}

  @Get('corregir')
  async reasignarRechazados() {
    const identificador = '6692229813'
    const cuenta = await this.aplicacionService.obtenerAplicacion(identificador)

    const mensajesFallidos = await MensajeRecibidoModel.findAll({
      attributes: ['id', 'mensaje'],
      where: {
        rechazado: true,
        id: {
        [Op.gte]: 2000
        }
      },
      limit: 1,
    })

    console.log(mensajesFallidos, 'data')

    for (let i = 0; i< mensajesFallidos.length; i++) {



      if(mensajesFallidos[0].mensaje.from) {
        
      
      const item = {
        plataforma: {
          id: 2,
          descripcion: 'whatsapp',
        },
        cuenta: {
          apikey: cuenta.apiKey,
          identificador: cuenta.identificador,
          token: cuenta.token,
        },
        timestamp: mensajesFallidos[0].mensaje.timestamp,
        message: {
          id: mensajesFallidos[0].mensaje.id,
          ...this.desifrarAttachments(mensajesFallidos[0].mensaje),
        },
        contact: {
          nombre: '',
          identificador: mensajesFallidos[0].mensaje.from
        },
      }

      this.httpClient.post(cuenta.redirect, [item]).subscribe({
        next: () => {
          MensajeRecibidoModel.update({rechazado: false}, {where: {id: mensajesFallidos[0].id}})
        },
        error: ({response}) => {
          console.error(response, 'trono')
        
      }
    })
  }
    }
    }


  @Post()
  async post(@Body() body: WhastAppDto, @Param('identificador') identificador: string) {
    //TODO: esperar la documentación de 360 dialog, esta con el entendido que para cada cuenta sea un webhook, si...
    //TODO: ... el identificador o wa_id viene en la data, cambiar este proceso
    const cuenta = await this.aplicacionService.obtenerAplicacion(identificador)

    if (!cuenta) {
      //TODO: notificar a algún correo pase esto
      // throw new NotFoundException('No existe esa aplicación')
      return
    }

    /*
      "statuses": [
    {
      "id": "gBGHUhZpEwQTnwIJOPtImFG-6sbB",
      "message": {
        "recipient_id": "5216691304139"
      },
      "recipient_id": "5216691304139",
      "status": "read",
      "timestamp": "1656408418",
      "type": "message"
    }
    ]*/
    if (body.statuses) {
      for (const i of body.statuses) {
        this.mensajeRecibido.statuses(
          {
            id: i.id,
            recipient_id: i.recipient_id,
            status: i.status,
            cuenta,
            errors: i?.errors?.map((i) => i.title).join() ?? '',
          },
          cuenta.redirect,
        )
      }
    }

    const messages = body.messages
    const contactos = new Map<string, WhastAppMessageContactsDto>()

    const tipoMensajes = await this.tipoMensaje.obtenerTipoMensaje('whatsapp')

    if (!body.contacts) {
      return
    }
    body.contacts.forEach((i) => contactos.set(i.wa_id, i))
    const mensajes: WebhookMensajeDto[] = []
    const data: CRMMessageDto[] = []
    for (const [i, message] of messages.entries()) {
      const tipoMensaje = tipoMensajes.find((i) =>
        Object.keys(i.configuracion.messages[0]).every((keys) => Object.keys(message).find((item) => item === keys)),
      )

      if (!tipoMensaje) {
        // throw new Error('no se encontro la configuración')
        return
        //TODO: enviar un mensaje de error
        //TODO: enviar un correo o mensaje a algún lado indicando que estan metiendo un tipomensaje que no está en la base de datos
      }
      console.log(tipoMensaje, 'tipo mensaje')

      if (
        tipoMensaje.nombre !== 'text' &&
        tipoMensaje.nombre !== 'default' &&
        tipoMensaje.nombre !== 'image' &&
        tipoMensaje.nombre !== 'video' &&
        tipoMensaje.nombre !== 'document'
      ) {
        //TODO: Hay un problema con los tipos de mensaje
        return
      }

      ///message.timestamp = +message.timestamp * 1000
      data.push({
        plataforma: {
          id: 2,
          descripcion: 'whatsapp',
        },
        cuenta: {
          apikey: cuenta.apiKey,
          identificador: cuenta.identificador,
          token: cuenta.token,
        },
        timestamp: message.timestamp,
        message: {
          id: message.id,
          ...this.desifrarAttachments(message),
        },
        contact: {
          nombre: contactos.get(message.from)?.profile.name ?? '',
          identificador: contactos.get(message.from)?.wa_id ?? body.contacts[i].wa_id,
        },
      })

      mensajes.push({
        cuentaId: cuenta.id,
        tipoMensaje: tipoMensaje.nombre,
        mensaje: message,
      })
    }
    if (!data.length) {
      throw new BadRequestException('No se proceso nada')
    }
    return this.mensajeRecibido.agregar(cuenta, mensajes, data)
  }

  desifrarAttachments(data: WhastAppMessageMessagesDto): {
    text: WhastAppMessageMessagesTextDto
    attachments: CRMMessageDtoAttachmentDto[]
  } {
    switch (data.type) {
      case 'text':
        return {
          text: {
            body: data.text.body,
          },
          attachments: [],
        }
        break
      case 'image':
        return {
          text: {
            body: data.image.caption || '',
          },
          attachments: [
            {
              id: data.image.id,
              type: 'image',
              url: data.image.link,
            },
          ],
        }
        break

      case 'video':
        return {
          text: {
            body: '',
          },
          attachments: [
            {
              id: data.video.id,
              type: 'video',
              url: data.video.link,
            },
          ],
        }
        break
      case 'document':
        return {
          text: {
            body: data.document.caption,
          },
          attachments: [
            {
              id: data.document.id,
              type: 'document',
              url: data.document.link,
            },
          ],
        }
        break
    }
  }
}
/*  
REVISAR EN POSTMAN  
{
  "contacts": [
    {
      "profile": {
        "name": "Monserrat Serrano"
      },
      "wa_id": "5216692231436"
    }
  ],
  "messages": [
    {
      "from": "5216692231436",
      "id": "ABGHUhZpIjFDbwIQUGc7CrvBCya8JW4C4QIx2w",
      "image": {
        "id": "487a8aac-00cf-412e-9d7a-d9e947e01115",
        "mime_type": "image/jpeg",
        "sha256": "73b6bcad2fa3e8e78924bfda5a30c5d2f5e337ef53e45adc49588739a7039ca2"
      },
      "timestamp": "2022-06-28T07:57:13.000Z",
      "type": "image"
    }
  ]*/
